<template>
  <div>
    <!-- <label path="storeid">{{ label }} <span class="red" v-if="requiredIcon">*</span></label> -->
    <!-- <label v-if="label" :for="id" class="form-label">{{ label }}<span v-if="requiredIcon"
        class="text-danger">*</span></label> -->
    <AutoComplete v-model="model" :optionLabel="getOptionLabelValue" :suggestions="items" @complete="search" :id="id"
      :disabled="disabled" :placeholder="placeholder" :autofocus="autofocus" @item-select="onItemSelect"
      :loading="loading">
      <template v-if="$slots.option" #option="slotProps">
        <slot name="option" :item="slotProps.option"></slot>
      </template>
    </AutoComplete>
    <!-- <span v-if="errorMessages.length" style="color: red">{{
      errorMessages[0]
    }}</span> -->

    <p v-if="errorMessages.length" class="err_msg_style">
      {{ errorMessages[0] }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed, watch } from "vue";
import { useField, defineRule, configure, validate } from "vee-validate";
import { required, email } from "@vee-validate/rules";

defineRule("required", required);

export default defineComponent({
  props: {
    //ajax: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: -1,
    },
    textField: {
      type: String,
      default: "name",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    valueField: {
      type: String,
      default: "value",
    },
    vid: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    rules: {
      type: Object,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    invalid: {
      type: String,
      default: "This field is required",
    },
    value: {},
    modelValue: {
      type: [String, Number, Object, Boolean, Array],
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    requiredIcon: {
      type: Boolean,
      defalut: false,
    },
    autofocus: {
      type: Boolean,
      defalut: false,
    },
    optionAttrs: {
      type: [Object, Function],
      default: () => ({}),
    },
  },
  emits: ["update:modelValue", "input", "itemSelect"],
  setup(props, { emit }) {
    const model = ref();
    const items1 = ref();

    onMounted(() => {
      model.value = props.modelValue;
      update();
    });

    function update() {
      emit("update:modelValue", model);
    }

    const search = (event) => {

      // setTimeout(() => {
      //   items1.value = props.items
      //   // .filter((item: any) =>
      //   //   item.label.toLowerCase().includes(event.query.toLowerCase())
      //   // );

      // }, 1000);
      emit("input", event);

    };

    const onInput = (event) => {
      emit("input", event);
    };

    const onItemSelect = (event) => {
      // Get the original selected item
      const originalItem = event.value;

      // Create a copy to avoid modifying the original
      let processedItem = { ...originalItem };

      // If optionAttrs is a function, apply it to get additional attributes
      if (typeof props.optionAttrs === 'function') {
        try {
          const extraAttrs = props.optionAttrs(originalItem);
          // Add the extraValue property that ItemOnChange expects
          if (extraAttrs && extraAttrs.extraValue !== undefined) {
            processedItem.extraValue = extraAttrs.extraValue;
          }
        } catch (error) {
          console.error("Error applying optionAttrs function:", error);
        }
      }

      // Update the model value with the selected item's label or name
      model.value = processedItem.label || processedItem.name;

      // Emit the model update event
      emit("update:modelValue", model.value);

      // Emit the item in the format that ItemOnChange expects
      emit("itemSelect", { value: processedItem });
    };

    watch(
      () => props.modelValue,
      (newVal) => {
        model.value = newVal;
      }
    );

    const { value, errorMessage, handleBlur, handleChange } = useField(
      props.name,
      props.rules,
      { initialValue: props.modelValue }
    );

    const errorMessages = computed(() => {
      return errorMessage.value ? [errorMessage.value] : [];
    });

    const fieldClass = computed(() => {
      return {
        "is-invalid": errorMessages.value.length > 0,
      };
    });

    const getOptionLabelValue = computed(() => {
      if (typeof props.optionAttrs === 'function') {
        return 'label'; // Default to 'label' when optionAttrs is a function
      } else if (props.optionAttrs && props.optionAttrs.text) {
        return props.optionAttrs.text;
      }
      return 'label'; // Default fallback
    });

    return {
      model,
      errorMessages,
      handleBlur,
      fieldClass,
      search,
      items1,
      onInput,
      onItemSelect,
      getOptionLabelValue
    };
  },
});
</script>
